var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-nav-main desktop-only", class: _vm.classes },
    [
      _c(
        "div",
        { ref: "tray", staticClass: "tray", class: { open: _vm.program } },
        [
          _vm.program
            ? _c("d-program-preview", {
                staticClass: "tray",
                attrs: { program: _vm.program },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "nav",
        {
          ref: "navbar",
          staticClass: "main",
          attrs: { role: "navigation" },
          on: { mousemove: _vm.scrollMenu },
        },
        [
          _c(
            "w-btn-icon",
            {
              staticClass: "menu-toggle",
              attrs: {
                href: "#",
                "no-hover": !_vm.menuHover,
                size: "xl",
                "aria-label": "Toggle Navigation",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleMenu.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade-super-fast", mode: "out-in" } },
                [
                  _vm.menuOpen
                    ? _c("i-down", {
                        key: "close",
                        attrs: { title: "Close menu" },
                      })
                    : _c("i-menu", {
                        key: "menu",
                        attrs: { title: "Featured programmes" },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "menu" }, [
            _c("div", {
              staticClass: "bg",
              style: { left: _vm.bgOffset + "px" },
            }),
            _c(
              "div",
              {
                ref: "menu",
                staticClass: "inner",
                style: { left: _vm.menuOffset + "px" },
              },
              _vm._l(_vm.menu, function (item, index) {
                return _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "hover-intent",
                        rawName: "v-hover-intent",
                        value: _vm.displayProgram,
                        expression: "displayProgram",
                      },
                    ],
                    key: index,
                    staticClass: "menu-item",
                    class: [_vm.slug(item), { hover: _vm.program === item }],
                    attrs: { to: item.url },
                    nativeOn: {
                      mouseover: function ($event) {
                        return _vm.setCurrentItem(item)
                      },
                      click: function ($event) {
                        return _vm.closeMenu.apply(null, arguments)
                      },
                    },
                  },
                  [_c("img", { attrs: { src: item.thumb } })]
                )
              }),
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }